
import React from 'react'
import { FiChevronRight  } from 'react-icons/fi' 
import { generateRandomUser, getRandomInt } from '../../@shared/utils'
import { Paginate } from './paginate'

export const CategoryListView = () =>{
    return (
        <section className='list'>
            <div className='listview'>
                <div className="heading flex">
                    <div>
                        <h1 className='title'>Pro Services in <b>App Design</b></h1>
                        <p className='description'>Lorem ipsum, dolor sit amet consectetur adipisicing elit.  </p>
                    </div>
                    <div className='flex'>
                        <b> See all </b>  <b><FiChevronRight /></b>
                    </div>
                </div>
                <ul className='box'>
                {Array.from(Array(11)).map((item,i)=>{
                    return (
                            <li>
                                <a href="##">
                                    <div
                                        className='bg'
                                        style={{
                                            background:`url(/assets/images/dummy/${ getRandomInt(1,55) }.png)`,
                                            backgroundSize:'contain',
                                        }}
                                    />
                                </a>
                                <div className='detail'>
                                    <a href="##" className="flex-start user cursor">
                                        <img src={`/assets/images/faces/${  getRandomInt(1,23) }.png`} className='avatar' alt="" />
                                        <div className="name">{generateRandomUser().name}</div>
                                    </a>
                                    <a href='##'>
                                        <div className="title">Lorem Ipsum Dolor Sit Amet</div>
                                    </a>
                                </div>
                            </li>
                    )
                })}
                
                </ul>
            </div>
            <Paginate />
        </section>
    )
}